export const FAILURE_REASON = {
  UNAUTHORIZED_ERROR: 'edrolo/net/UNAUTHORIZED_ERROR',
  SYSTEM_ERROR: 'edrolo/net/SYSTEM_ERROR',
  NETWORK_ERROR: 'edrolo/net/NETWORK_ERROR',
  NOT_FOUND_ERROR: 'edrolo/net/NOT_FOUND_ERROR',
  GATEWAY_TIMEOUT: 'edrolo/net/GATEWAY_TIMEOUT',
  BAD_REQUEST: 'edrolo/net/BAD_REQUEST',
};

// this is mocked to be a shorter values in setupTestFramework.js
export const NETWORK_BACKOFF_INTERVAL = 300;
export const NETWORK_MAX_RETRIES = 6;
